module.exports = __webpack_public_path__ + "img/25ne.4ee0b6a1.svg";